import { render, staticRenderFns } from "./HomeCategories.vue?vue&type=template&id=9dfb91f6&scoped=true"
import script from "./HomeCategories.vue?vue&type=script&lang=js"
export * from "./HomeCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfb91f6",
  null
  
)

export default component.exports